// extracted by mini-css-extract-plugin
export default {"field":"input_field__-NoGB","label":"input_label__P-xbd"};